angular.module('component-payments.format.expire', [])
	.directive('ctpaymentsFormatExpiry', ['Common', '$filter', paymentsFormatExpiryDirective]);

function paymentsFormatExpiryDirective (Common, $filter) {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (scope, elem, attr, ctrl) {
			elem.bind('keypress', restrictExpiry);
			elem.bind('keypress', formatExpiry);
			elem.bind('keypress', formatForwardSlash);
			elem.bind('keypress', formatForwardExpiry);
			elem.bind('keydown', formatBackExpiry);

			ctrl.$parsers.push(parseExpiry);
			ctrl.$formatters.push(getFormattedExpiry);

			function restrictExpiry(e) {
				var $target, digit, value;

				$target = angular.element(e.currentTarget);
				digit = String.fromCharCode(e.which);

				if (!/^\d+$/.test(digit) && !e.meta && e.keyCode >= 46) {
					e.preventDefault();
					return;
				}

				value = $target.val() + digit;
				value = value.replace(/\D/g, '');

				if (value.length > 6) {
					e.preventDefault();
					return;
				}
			}

			function formatExpiry(e) {
				var $target, digit, val;

				digit = String.fromCharCode(e.which);

				if (!/^\d+$/.test(digit) && !e.meta && e.keyCode >= 46) {
					e.preventDefault();
					return;
				}

				$target = angular.element(e.currentTarget);
				val = $target.val() + digit;

				if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
					e.preventDefault();
					return $target.val("0" + val + " / ");

				} else if (/^\d\d$/.test(val)) {
					e.preventDefault();
					return $target.val("" + val + " / ");

				}
			}

			function formatForwardExpiry(e) {
				var $target, digit, val;

				digit = String.fromCharCode(e.which);

				if (!/^\d+$/.test(digit) && !e.meta && e.keyCode >= 46) {
					return;
				}

				$target = angular.element(e.currentTarget);
				val = $target.val();

				if (/^\d\d$/.test(val)) {
					return $target.val("" + val + " / ");
				}
			}

			function formatForwardSlash(e) {
				var $target, slash, val;

				slash = String.fromCharCode(e.which);

				if (slash !== '/') {
					return;
				}

				$target = angular.element(e.currentTarget);
				val = $target.val();

				if (/^\d$/.test(val) && val !== '0') {
					return $target.val("0" + val + " / ");
				}
			}

			function formatBackExpiry(e) {
				var $target, value;

				if (e.meta) {
					return;
				}

				$target = angular.element(e.currentTarget);
				value = $target.val();

				if (e.which !== 8) {
					return;
				}

				if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
					return;
				}

				if (/\d(\s|\/)+$/.test(value)) {
					e.preventDefault();
					return $target.val(value.replace(/\d(\s|\/)*$/, ''));

				} else if (/\s\/\s?\d?$/.test(value)) {
					e.preventDefault();
					return $target.val(value.replace(/\s\/\s?\d?$/, ''));

				}
			}

			function parseExpiry(value) {
				if (value != null) {
					var obj = Common.parseExpiry(value);
					var expiry = new Date(obj.year, obj.month - 1);
					return $filter('date')(expiry, 'MM/yyyy');
				}
				return null;
			}

			function getFormattedExpiry(value) {
				if (value != null) {
					var obj = Common.parseExpiry(value);
					var expiry = new Date(obj.year, obj.month - 1);
					return $filter('date')(expiry, 'MM / yyyy');
				}
				return null;
			}
		}
	}
}

module.exports = 'component-payments.format.expire';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/formatters/expire.js
 ** module id = 89
 ** module chunks = 1
 **/